import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const Container: StyleRule = () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pxToRem(6),
});

export const Button: StyleRule = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f6f4',
    color: '#000',
    width: pxToRem(30),
    height: pxToRem(30),
    borderRadius: '50%',
    padding: 0,
    flexShrink: 0,
});

export const ButtonIcon: StyleRule = () => ({
    width: pxToRem(16),
    height: pxToRem(16),
});
